import { ConceptCategory } from '../../models/Entities/Contracts/ConceptCategory';
import { CommonState } from '../common/state/commonState';

export interface ConceptCategoryState extends CommonState<ConceptCategory> {
  selected: ConceptCategory | undefined;
}

export const ConceptCategoryUnloadState: ConceptCategoryState = {
  // loading all
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,

  // loading one
  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,

  // adding new one
  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,

  // updating one
  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,

  // deleting one
  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,

  list: [],
  error: undefined,
  selected: undefined
};
